<template>
  <div>


    <div style="z-index: 9999;  position:fixed; top: 1em; right: 1em; text-align: center">
      <p>{{ username }}</p>
      <button
        style="font-weight: bold; width: 5em; border-radius:5px; color:white; background-color: #1988f9; border: none; padding: 0.5em; margin: 0 auto; display: block"
        @click="logout">Salir
      </button>

    </div>


    <ChatComponent :can-send-files="true" v-if="initialized" @upload="uploadFile" @download="downloadFile"
                   :storageMethod="1"
                   :config="config" :chatActions="false"
                   :contacts="contacts" :auth="auth"></ChatComponent>
  </div>
</template>

<script>
import axios from 'axios';
import {apiPath, loginPath, firebaseConfig} from '../env';
import sessionStorage from 'sessionstorage';
import AWS from 'aws-sdk';


export default {
  name: "home",
  data() {

    return {

      initialized: false,
      s3: null,
      aws: {},
      config: firebaseConfig,
      contacts: [],
      auth: {
        username: '',
        password: ''
      },

      username: ''
    }
  },

  computed: {},
  methods: {

    logout: function () {
      sessionStorage.clear();
      window.location.reload();
    },

    downloadFile: function (message, resolve, reject) {

      this.s3.getObject({Bucket: this.aws.bucket, Key: message.content.url}, (err, data) => {
        if (err) reject(err.message);
        else resolve(data);
      });
    },

    uploadFile: function (data, resolve, reject) {

      let payload = {
        Bucket: this.aws.bucket,
        Body: data.file,
        Key: data.userId + '/' + data.uniqueId
      };

      this.s3.putObject(payload, (err) => {
        if (err) reject(err.message);
        else resolve();
      });
    },


    async initialize() {

      let username = sessionStorage.getItem('username') + '-' + sessionStorage.getItem('shortNumber') + '@primafrio.com';
      let password = sessionStorage.getItem('firebaseId');

      this.auth = {
        username: username,
        password: password
      };

      let aws = JSON.parse(sessionStorage.getItem('awsCredentials'));


      AWS.config.update({
        region: "us-east-2",
        credentials: new AWS.Credentials(aws.AccessKeyId, aws.SecretAccessKey, aws.SessionToken)
      });

      this.s3 = new AWS.S3();
      this.aws = aws;


      let res = await axios.get(apiPath + '/contacts', {headers: {os: 2, token: sessionStorage.getItem('token')}});

      if (res.data.code === 1) {

        //TRY RELOGIN

        let payload = {
          username: sessionStorage.getItem('username'),
          password: sessionStorage.getItem('password')
        };

        axios.post(loginPath + '/login/credentials', payload).then(res => {

          let result = res.data;

          if (result.code === 100) {

            if (result.data.user.permissions['chat-web'].access) {

              sessionStorage.setItem('username', payload.username);
              sessionStorage.setItem('password', payload.password);
              sessionStorage.setItem('user', result.data.user.name);
              sessionStorage.setItem('token', result.data.sessionToken);
              sessionStorage.setItem('shortNumber', result.data.user.shortNumber);
              sessionStorage.setItem('awsCredentials', JSON.stringify(result.data.awsCredentials));
              sessionStorage.setItem('firebaseId', result.data.user.firebaseId);

              this.username = result.data.user.name;

              return this.initialize();

            } else {
              this.logout();
            }

          } else {
            this.logout();
          }

        });

      } else {

        this.contacts = res.data.data;
        this.initialized = true;

      }


    }
  },

  created() {
    this.initialize();
    this.username = sessionStorage.getItem('user');
  }
}
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/Home.vue